const system = require('./locale/system.json');
const en = require('./locale/en.json');
const da = require('./locale/da.json');
const se = require('./locale/se.json');
const no = require('./locale/no.json');

export default {
  system, en, da, se, no,
};
